module.exports = __webpack_public_path__ + "img/BO.feb8b3df.svg";